import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reportActionCreators } from '../../../stores/lis-report-store';
import { navActionCreators } from '../../../stores/lis-nav-store';

class ShareReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddresses: '',
            emailSubject: '',
            isSharing: false
        };
        this.handleEmailAddressChange = this.handleEmailAddressChange.bind(this);
        this.handleEmailSubjectChange = this.handleEmailSubjectChange.bind(this);
        this.sendReport = this.sendReport.bind(this);
    }

    componentDidMount() {
        this.setState({
            emailSubject: this.props.emailSubject
        })
    }

    handleEmailAddressChange(e) {
        this.setState({
            emailAddresses: e.target.value
        });
    }

    handleEmailSubjectChange(e) {
        this.setState({
            emailSubject: e.target.value
        });
    }

    sendReport() {
        this.setState({
            isSharing: true
        });

        const body = {
            link: window.location.href,
            addresses: this.state.emailAddresses,
            subject: this.state.emailSubject
        }

        this.props.actions.shareReport(body)
            .then(() => {
                this.props.actions.makeToast([{ message: "Share Successful", type: "success" }]);
                this.setState({
                    isSharing: false,
                    emailAddresses: '',
                    emailSubject: ''
                }, () => {
                    this.props.toggleShareForm();
                })
            }).catch(err => {
                if (err === "Aborted") {
                    return
                }
                this.setState({
                    isSharing: false
                })
                this.props.actions.makeToast([{ message: "Share Failed", type: "failure" }]);
            })
    }

    render() {
        let notesMessage = '';
        if (this.props.source === 'composite-view') {
            notesMessage = "Your watchlist's notes will not be shared.";
        } else if (this.props.source === 'reports-true') {
            notesMessage = "Your watchlist(s)' notes will not be shared.";
        } else {
            notesMessage = '';
        }
        return (<div onClick={!this.state.isSharing ? this.props.toggleShareForm : null} className="modal-backdrop">
            <div className="modal share-report" onClick={e => e.stopPropagation()}>
                <div className='modal-header'>
                    <div className='title'>Share</div>
                    <button onClick={!this.state.isSharing ? this.props.toggleShareForm : null} className="close-cross" aria-label="close modal" />
                </div>
                <div className='modal-body'>
                    <p className='big'>{`Share a link to your ${this.props.source === 'composite view' ? 'composite view' : 'report'}.`}</p>
                    <p className='small'>{`The link expires 72 hours from its creation. ${notesMessage}`}</p>
                    <div className='dlas-forms inputs'>
                        <label htmlFor="email-addresses-to-send-to" className="label">Email Addresses (separate email addresses by a comma)</label>
                        <div className="inline-list">
                            <input id="email-addresses-to-send-to" style={{ width: "100%" }} aria-label="Email addresses to send to" onChange={this.handleEmailAddressChange} value={this.state.emailAddresses} placeholder="Email addresses to send to" />
                        </div>
                        <label htmlFor='email-subject'>Email Subject</label>
                        <div className='inline-list'>
                            <input id='email-subject' style={{ width: "100%" }} onChange={this.handleEmailSubjectChange} value={this.state.emailSubject} />
                        </div>
                    </div>
                    <div className="inline-list buttons">
                        {this.state.isSharing &&
                            <div className="small-spinner"></div>
                        }
                        <button type="button" disabled={this.state.isSharing || !this.state.emailAddresses} className="button" onClick={this.sendReport}>Share</button>
                        <button type="button" disabled={this.state.isSharing} className="button secondary" onClick={this.props.toggleShareForm}>Close</button>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default connect(
    (state) => {
        const { report, nav } = state;
        return {
            report,
            nav

        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, reportActionCreators, navActionCreators), dispatch)
        }
    }
)(ShareReport);
